// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1644":"723cf24e","2088":"d77a4961","2292":"723cf24e","2374":"9c240dbe","2452":"723cf24e","3295":"06b87569","6540":"723cf24e","9008":"61d6daca","9136":"723cf24e"}[chunkId] + ".chunk.css";
};